import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Suspense fallback for a route whose code chunk is still downloading.
 *
 * Deliberately says nothing: no text, no empty-state illustration, no error
 * surface. An operator must never read "the screen is loading its JS" as
 * "there is no data" or "something failed" — those two readings drive real
 * trading decisions, and this component is on screen for a few hundred ms
 * on the first visit to each route (never again, the chunk is cached).
 */
export const RouteFallback = () => (
  <Box
    role="status"
    aria-label="Loading"
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: 200,
      height: '100%'
    }}
  >
    <CircularProgress size={28} />
  </Box>
);
